const chipLinkClasses =
  'border-gray-350 mr-3 mt-2 block border border-solid py-2 px-3 text-[0.9rem] leading-[1.2rem] transition-colors duration-300 hover:bg-blue-500 hover:text-white';

const chipTextClasses = 'text-[0.9rem] leading-[1.2rem]';
const chipLinkColorClasses = '';

const chipBlogTheme = {
  chipLinkClasses,
  chipTextClasses,
  chipLinkColorClasses,
};

export default chipBlogTheme;
